import { createRoot } from 'react-dom/client';
import { getSmartscriptFromQuery, setLocalStorage } from './lib/utils';
import {
	getOktaAuthConfig,
	getSmartscriptConfig,
} from './smartscriptConfig';
import App from './App';
import type { SmartScriptOktaConfig } from './types';
import { datadogInit } from './lib/datadog';

datadogInit();

const smartscriptName = getSmartscriptFromQuery();
const smartscriptConfigs = getSmartscriptConfig(smartscriptName);

const smartScriptOktaConfigs: SmartScriptOktaConfig[] = smartscriptConfigs.map((smartscriptConfig) => ({
	tokenName: smartscriptConfig.tokenName,
	path: smartscriptConfig.path,
	oktaConfig: getOktaAuthConfig(smartscriptConfig),
}));

setLocalStorage('smartscript', smartscriptName);
setLocalStorage('smartscriptLoginQueue', JSON.stringify(smartScriptOktaConfigs.map(cfg => cfg.path)));

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(<App smartScriptOktaConfigs={smartScriptOktaConfigs} />);
